import { render } from "./DefaultCardWeb.vue?vue&type=template&id=77b08b9a&scoped=true&ts=true"
import script from "./DefaultCardWeb.vue?vue&type=script&lang=ts"
export * from "./DefaultCardWeb.vue?vue&type=script&lang=ts"

import "./card.scss?vue&type=style&index=0&id=77b08b9a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b08b9a"]])

export default __exports__